export interface TEmail {
  id?: string;
  email: string;
  primary?: boolean;
}

export interface TPhone {
  id?: string;
  prefix: string | null;
  number: string;
  is_primary?: boolean;
}

/** Form-only keys stripped when checking whether a phone row has user data. */
export type TPhoneFormMeta = {
  _formType?: string;
};

/** True when the phone has no prefix or number (ignores `id` / `_formType`). */
export function isPhoneEntryEmpty(phone: (TPhone & TPhoneFormMeta) | null | undefined): boolean {
  if (!phone) return true;
  const { prefix, number } = phone;
  const hasPrefix = prefix !== undefined && prefix !== null && prefix !== "";
  const hasNumber = number !== undefined && number !== null && number !== "";
  return !hasPrefix && !hasNumber;
}

export const TDefaultPhone: TPhone = {
  prefix: null,
  number: "",
  is_primary: false,
};

export function getPrimaryEmail(emails?: TEmail[] | null): TEmail | undefined {
  return emails?.find((email) => email.primary) ?? emails?.[0];
}

export function getPrimaryPhone(phones?: TPhone[] | null): TPhone | undefined {
  return phones?.find((phone) => phone.is_primary) ?? phones?.[0];
}
